import { render, staticRenderFns } from "./TSysLanguageList.vue?vue&type=template&id=58326076&scoped=true&"
import script from "./TSysLanguageList.vue?vue&type=script&lang=js&"
export * from "./TSysLanguageList.vue?vue&type=script&lang=js&"
import style0 from "./TSysLanguageList.vue?vue&type=style&index=0&id=58326076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58326076",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58326076')) {
      api.createRecord('58326076', component.options)
    } else {
      api.reload('58326076', component.options)
    }
    module.hot.accept("./TSysLanguageList.vue?vue&type=template&id=58326076&scoped=true&", function () {
      api.rerender('58326076', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/TSysLanguageList.vue"
export default component.exports